import React, {useEffect, useState} from 'react'
import PageLayout from '../../../components/layout/PageLayout'
import useQueryGetInvoices from '../../../hooks/api/leader/useQueryGetInvoices'
import WizPagination from '../../../components/pagination/WizPagination'
import Text from '../../../components/text/Text'
import ic_primary_check from '../../../assets/images/ic_check_primary.png'
import ic_warning from '../../../assets/images/ic_warning_circle_red.png'
import ic_right_arrow from '../../../assets/images/ic_arrow_right.png'
import WizImage from '../../../components/image/WizImage'
import TableHeader from '../../../components/table/TableHeader'
import {useDisplayNumber} from '../../../utils/number'
import {useString} from '../../../utils/string'
import Span from '../../../components/text/Span'
import useNavigation from '../../../hooks/useNavigation'

interface IProps {
    className?: string
}

const InvoicesPage: React.FC<IProps> = ({className}) => {
    const [currentPage, setCurrentPage] = useState(1)

    const {data, refetch} = useQueryGetInvoices(currentPage)
    const [extendId, setExtendId] = useState('')

    const {floorBalance} = useDisplayNumber()
    const {goCopierDetail} = useNavigation()
    const {shortCutString} = useString()

    useEffect(() => {
        refetch()
    }, [currentPage])

    return (
        <PageLayout title={'Invoices'}>
            <section className={'flex flex-col gap-y-[10px] mt-[30px]'}>
                <TableHeader className={'grid-cols-[130px_1fr_1fr_100px_230px] md:hidden'}>
                    <Text className={'pl-[10px]'}>Status</Text>
                    <Text>User Name</Text>
                    <Text className={''}>Leader Name</Text>
                    <Text className={''}>Amount</Text>
                    <Text className={'text-right pr-[10px]'}>Paid Date</Text>
                </TableHeader>
                {data?.data?.map(invoice => (
                    <div
                        onClick={() => {
                            if (extendId !== invoice?.id) {
                                setExtendId(invoice?.id)
                            } else if (extendId === invoice?.id) {
                                goCopierDetail(invoice?.bot_id)
                            }
                        }}
                        key={invoice?.id}
                        className={`border border-line02 rounded-[5px] pt-[30px] px-[20px] pb-[30px] cursor-pointer
                        ${
                            extendId === invoice?.id
                                ? `${
                                      invoice?.status === 'paid'
                                          ? 'border-primary bg-[#02BB6F1A]'
                                          : 'border-font_red bg-font_red bg-opacity-10'
                                  }`
                                : ' bg-white'
                        }
                         ${
                             invoice?.status === 'paid'
                                 ? 'hover:border-primary hover:bg-[#02BB6F1A]'
                                 : 'hover:border-font_red hover:bg-font_red hover:bg-opacity-10'
                         }`}>
                        <div
                            className={
                                'grid grid-cols-[130px_1fr_1fr_100px_230px] gap-x-[12px] items-center px-[10px] md:grid-cols-1 md:gap-y-[10px]'
                            }>
                            {invoice?.status === 'paid' ? (
                                <div className={'flex items-center gap-x-[5px]'}>
                                    <WizImage src={ic_primary_check} className={'w-[24px]'} />
                                    <Text className={'text-ti1'}>{'Paid'}</Text>
                                </div>
                            ) : (
                                <div className={'flex items-center gap-x-[5px]'}>
                                    <WizImage src={ic_warning} className={'w-[24px]'} />
                                    <Text className={'text-ti1 text-font_red'}>
                                        {new Date(invoice?.to_time).getTime() < new Date().getTime()
                                            ? 'Overdue'
                                            : 'Pending'}
                                    </Text>
                                </div>
                            )}

                            <Text className={'text-ti2'}>
                                <Span className={'hidden md:inline '}>User Name : </Span> {invoice?.user_nickname}
                            </Text>
                            <Text className={'text-ti2 text-font_leader'}>
                                <Span className={'hidden md:inline '}>Leader Name : </Span> {invoice?.leader_name}
                            </Text>
                            <Text className={`${invoice?.status !== 'paid' && 'text-font_red text-ti2'}`}>
                                <Span className={'hidden md:inline '}>Amount : </Span> ${invoice?.amount}
                            </Text>
                            <div>
                                <Text className={'text-right text-body3 text-font02'}>
                                    Paid At : {invoice?.paid_at ? new Date(invoice?.paid_at).toLocaleString() : '-'}
                                </Text>
                            </div>
                        </div>
                        <div
                            className={`mt-[30px] px-[10px] py-[15px] bg-white border border-line02 rounded-[5px] relative grid grid-cols-[1fr_1fr_1fr_230px_1fr] text-center md:grid-cols-2 md:gap-y-[10px] sm:grid-cols-1 sm:gap-y-[20px] ${
                                extendId !== invoice?.id && 'hidden'
                            }`}>
                            <div className={'space-y-[3px]'}>
                                <Text className={'text-ti3 text-font02'}>Paid Code</Text>
                                <Text className={'text-body2 text-font02'}>{invoice?.status?.toUpperCase()}</Text>
                            </div>
                            <div>
                                {invoice?.cut_percent !== 30 && (
                                    <div className={'space-y-[3px]'}>
                                        <Text className={'text-ti3 text-font02'}>Fee Percent</Text>
                                        <div className={'flex items-center justify-center gap-x-[5px]'}>
                                            <Text className={'text-ti2 text-font02 line-through'}>30%</Text>
                                            <WizImage src={ic_right_arrow} className={'w-[10px]'} />
                                            <Text className={'text-font_red text-ti2'}>{invoice?.cut_percent}%</Text>
                                        </div>
                                    </div>
                                )}
                                {invoice?.cut_percent === 30 && (
                                    <div className={'space-y-[3px]'}>
                                        <Text className={'text-ti3 text-font02'}>Fee Percent</Text>
                                        <Text className={'text-ti2 text-font02'}>30%</Text>
                                    </div>
                                )}
                            </div>
                            <div className={'space-y-[3px]'}>
                                <Text className={'text-ti3 text-font02'}>Amount Due</Text>
                                <Text className={`${invoice?.amount - invoice?.paid > 0 && 'text-font_red text-ti2'}`}>
                                    ${invoice?.amount - invoice?.paid}
                                </Text>
                            </div>
                            <div className={'space-y-[3px]'}>
                                <Text className={'text-ti3 text-font02'}>Invoice Date </Text>
                                <Text className={'text-font03 text-body3'}>
                                    from : {new Date(invoice?.from_time)?.toLocaleString()}
                                </Text>
                                <Text className={'text-font03 text-body3'}>
                                    to : {new Date(invoice?.to_time)?.toLocaleString()}
                                </Text>
                                <Text className={'text-font03 text-body3'}>
                                    overDue : {new Date(invoice?.due_at)?.toLocaleString()}
                                </Text>
                            </div>
                            <div className={'space-y-[3px]'}>
                                <Text className={'text-ti3 text-font02'}>High Water Mark Profit</Text>
                                <Text className={'text-ti2 text-font_green'}>
                                    ${floorBalance(invoice?.period_profit, 100, false)}
                                </Text>
                            </div>
                        </div>
                    </div>
                ))}
            </section>
            <WizPagination
                totalPage={data?.pageInfo?.total_count}
                currentPage={currentPage}
                onPageChange={item => {
                    setCurrentPage(item)
                    window.scrollTo(0, 0)
                }}
            />
        </PageLayout>
    )
}

export default InvoicesPage
